import createLucideIcon from '../createLucideIcon';

const BluetoothConnected = createLucideIcon('BluetoothConnected', [
  ['path', { d: 'm7 7 10 10-5 5V2l5 5L7 17', key: '1q5490' }],
  ['line', { x1: '18', x2: '21', y1: '12', y2: '12', key: '1rsjjs' }],
  ['line', { x1: '3', x2: '6', y1: '12', y2: '12', key: '11yl8c' }],
]);

export default BluetoothConnected;
